/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentPersonCoursesFilterViewModel } from "../types/IndividualPaymentPersonCoursesFilterViewModel.ts";

export const individualPaymentPersonCoursesFilterViewModelSchema = z.object({
  ourNumber: z.string().nullish(),
  invoiceNumber: z.string().nullish(),
  thirdPartyCpf: z.string().nullish(),
  thirdPartyCnpj: z.string().nullish(),
}) as unknown as ToZod<IndividualPaymentPersonCoursesFilterViewModel>;
